/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";

import UserProfile from "views/UserProfile.js";

import Indikator from "views/Indikator";
import IndikatorDesa from "views/Indikator-Desa";
import InputIndikator from "views/InputIndikator";
import DataStunting from "views/DataStunting";

import UsersNusafuaAdminduk from "views/UsersMaiFali";
import RekomendasiDetail from "views/RekomendasiDetail";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/indikator",
    name: "Data Disabilitas",
    rtlName: "بيانات ذوي الاحتياجات الخاصة",
    icon: "tim-icons icon-bullet-list-67",
    component: Indikator,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/indikator-desa",
    name: "Disabilitas per Wilayah",
    rtlName: "الرموز",
    icon: "tim-icons icon-atom",
    component: IndikatorDesa,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/input-indikator",
    name: "Jenis Disabilitas",
    rtlName: "الرموز",
    icon: "tim-icons icon-pencil",
    component: InputIndikator,
    layout: "/admin",
    sidebar: true,
    user: true,
  },

  {
    path: "/users-maifali",
    name: "Users NUSAFUA-ADMINDUK",
    rtlName: "ملف تفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: UsersNusafuaAdminduk,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تفي للمستخدم",
    icon: "tim-icons icon-badge",
    component: UserProfile,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/rekomendasi-detail",
    name: "Detail Rekomendasi",
    component: RekomendasiDetail,
    layout: "/admin",
  },
];
export default routes;
